module.exports = __webpack_public_path__ + "img/icon_popup_close.db972d99.png";